import type { FieldPath } from 'react-hook-form'
import type { InstallationCreateFormInput, InstallationGoodsFamily } from '@/features/installations/installation-create.schema'

export const installationCreateGoodsFamilyValues: InstallationGoodsFamily[] = [
  'ALUMINIUM',
  'CEMENT',
  'IRONANDSTEEL',
  'ELECTRICITY',
  'CHEMICALS',
  'FERTILIZERS',
]

export const installationCreateStep1FieldPaths = [
  'name',
  'localName',
  'goodsFamily',
  'description',
] as const satisfies readonly FieldPath<InstallationCreateFormInput>[]

export const installationCreateStepLatinFieldPaths = [
  'street',
  'street2',
  'streetNumber',
  'country',
  'postCode',
  'poBox',
  'city',
  'unlocode',
  'longitude',
  'latitude',
] as const satisfies readonly FieldPath<InstallationCreateFormInput>[]

export const installationCreateStepLocalFieldPaths = [
  'localStreet',
  'localStreet2',
  'localStreetNumber',
  'localPostCode',
  'localPoBox',
  'localCity',
] as const satisfies readonly FieldPath<InstallationCreateFormInput>[]
